import { render, staticRenderFns } from "./ModuleEmbed.vue?vue&type=template&id=d556157e&scoped=true&"
import script from "./ModuleEmbed.vue?vue&type=script&lang=js&"
export * from "./ModuleEmbed.vue?vue&type=script&lang=js&"
import style0 from "./ModuleEmbed.vue?vue&type=style&index=0&id=d556157e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d556157e",
  null
  
)

export default component.exports